import { LabelFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import StandardControl from "@insite/shell-public/Components/StandardControl";
import { EditorTemplateProps } from "@insite/shell-public/EditorTemplateProps";
import * as React from "react";

export default class LabelField extends React.Component<EditorTemplateProps<string, LabelFieldDefinition>> {
    render() {
        return <StandardControl fieldDefinition={this.props.fieldDefinition}></StandardControl>;
    }
}
